module.exports = __webpack_public_path__ + "static/img/9.a30c2244.png";